import { NgModule, ModuleWithProviders, forwardRef } from '@angular/core';
import { GlobalRef, BrowserGlobalRef } from './global-variables';

@NgModule({})
export class SharedModule {

    static forBrowser(): ModuleWithProviders {
        return {
            ngModule: forwardRef(() => SharedModule),
            providers: [
                { provide: GlobalRef, useClass: BrowserGlobalRef }
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/common/shared.module.ts